import { getNumberOfSavedResources } from '../../primary-nav-rse/js/global';

function containsObject(obj, list) {
    let i;
    for (i = 0; i < list.length; i++) {
        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
            return true;
        }
    }
    return false;
}

function toggleSaveButtons() {
    const saveButton = document.querySelector('.js-save-resource');
    const forgetButton = document.querySelector('.js-forget-resource');

    saveButton.classList.toggle('hide');
    forgetButton.classList.toggle('hide');
}

function addToSavedResourcesInLocalStorage(newObject) {
    /* get savedResources local storage array */
    const savedResourcesArray = JSON.parse(
        window.localStorage.getItem('savedResources')
    );

    /* append new object to array */
    savedResourcesArray.push(newObject);

    window.localStorage.setItem(
        'savedResources',
        JSON.stringify(savedResourcesArray)
    );
    toggleSaveButtons();
    getNumberOfSavedResources();
}

function removeFromSavedReourcesInLocalStorage(newObject) {
    /* get savedResources local storage array */
    let savedResourcesArray = JSON.parse(
        window.localStorage.getItem('savedResources')
    );

    const indexOfExisting = savedResourcesArray.findIndex(
        (item) => item.assetId === newObject.assetId
    );

    if (indexOfExisting > -1) {
        savedResourcesArray.splice(indexOfExisting, 1);
        if (!savedResourcesArray) {
            savedResourcesArray = [];
        }
        window.localStorage.setItem(
            'savedResources',
            JSON.stringify(savedResourcesArray)
        );
        toggleSaveButtons();
        getNumberOfSavedResources();
    }
}

export default function _saveResource() {
    if (window.localStorage.getItem('savedResources') == null) {
        window.localStorage.setItem('savedResources', '[]');
    }

    const saveButton = document.querySelector('.js-save-resource');
    const forgetButton = document.querySelector('.js-forget-resource');

    if (saveButton || forgetButton) {
        /* Get data from <meta> tags */
        const assetId = document
            .querySelector('meta[name="assetId"]')
            .getAttribute('content');
        const link = document
            .querySelector('meta[name="resource.tile.link"]')
            .getAttribute('content');

        const featureCard = document
            .querySelector('meta[name="resource.tile.feature.card"]')
            .getAttribute('content');
        const imageUrl = document
            .querySelector('meta[name="resource.tile.image"]')
            .getAttribute('content');
        const imageUrlForDetailsPage = document
            .querySelector('meta[name="resource.page.image"]')
            .getAttribute('content');
        const partnerLogo = document
            .querySelector('meta[name="resource.tile.partner.logo"]')
            .getAttribute('content');
        const overflowImage = document
            .querySelector('meta[name="resource.tile.overflow.image"]')
            .getAttribute('content');
        const pageTitle = document
            .querySelector('meta[name="resource.tile.title"]')
            .getAttribute('content');
        const text = document
            .querySelector('meta[name="resource.tile.text"]')
            .getAttribute('content');
        const downloadLink = document
            .querySelector('meta[name="resource.tile.download.link"]')
            .getAttribute('content');
        const websiteLink = document
            .querySelector('meta[name="resource.tile.website.link"]')
            .getAttribute('content');

        const type = document
            .querySelector('meta[name="resource.tile.type"]')
            .getAttribute('content');
        const tags = document
            .querySelector('meta[name="resource.tile.tags"]')
            .getAttribute('content');
        const stage = document
            .querySelector('meta[name="resource.tile.stage')
            .getAttribute('content');
        const gradeLevel = document
            .querySelector('meta[name="resource.tile.grade.level')
            .getAttribute('content');
        const learningMode = document
            .querySelector('meta[name="resource.tile.learning.mode')
            .getAttribute('content');

        class SavedResource {
            constructor(
                id,
                cardLink,
                cardFeatureCard,
                cardImageUrl,
                pageImageUrl,
                partnerLogoUrl,
                cardOverflowImage,
                title,
                cardText,
                cardDownloadLink,
                cardWebsiteLink,
                cardType,
                cardTags,
                cardStage,
                cardGradeLevel,
                cardLearningMode
            ) {
                this.assetId = id;
                this.link = cardLink;
                this.featureCard = cardFeatureCard;
                this.imageUrl = cardImageUrl;
                this.pageImageUrl = pageImageUrl;
                this.partnerLogoUrl = partnerLogoUrl;
                this.overflowImage = cardOverflowImage;
                this.pageTitle = title;
                this.text = cardText;
                this.downloadUrl = cardDownloadLink;
                this.websiteUrl = cardWebsiteLink;
                this.type = cardType;
                this.tags = cardTags;
                this.stage = cardStage;
                this.gradeLevel = cardGradeLevel;
                this.learningMode = cardLearningMode;
            }
        }

        /* Create new object from data in <meta> tags */
        const newSavedData = new SavedResource(
            assetId,
            link,
            featureCard,
            imageUrl,
            imageUrlForDetailsPage,
            partnerLogo,
            overflowImage,
            pageTitle,
            text,
            downloadLink,
            websiteLink,
            type,
            tags,
            stage,
            gradeLevel,
            learningMode
        );

        /* Check if this page is already saved */
        const savedResources = JSON.parse(
            window.localStorage.getItem('savedResources')
        );
        const alreadyPresent = containsObject(newSavedData, savedResources);

        if (alreadyPresent) {
            toggleSaveButtons();
        }

        forgetButton.addEventListener('click', () => {
            removeFromSavedReourcesInLocalStorage(newSavedData);
        });
        saveButton.addEventListener('click', () => {
            addToSavedResourcesInLocalStorage(newSavedData);
        });
    }
}

window.addEventListener('DOMContentLoaded', _saveResource);
